import Backbone from 'backbone'
import $ from 'jquery'
import WidgetView from '../widget-view'
import DatasetFilterWidgetConfig from './dataset-filter-widget-config'
import _ from 'lodash'
import template from './dataset-filter-widget-view.hbs'
import {DATASET_FETCH_PROPERTIES} from '../maestro'
import i18n from 'scoreboard/components/i18n'
import filterText, {
	isSimpleOperator
} from 'scoreboard/datasets/filters/filter-text'
import FilterWizard from 'scoreboard/datasets/filters/filter-wizard'
import dropdown from 'scoreboard/components/dropdown'
import layoutManager from 'scoreboard/components/layout-manager'
import operatorOptions from 'scoreboard/datasets/filters/operator-options'
import twoSteps from 'scoreboard/datasets/filters/two-steps'
import calendars from 'scoreboard/components/calendars'
import Dataset, {isEditField} from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset
import Tooltip from 'scoreboard/components/tooltip'
const VALUE_MIN_WIDTH = 65
import WidgetEmptyState from '../widget-empty-state'
import DatasetTreeItemSelectorTooltip from 'scoreboard/datasets/dataset-tree-item-selector-tooltip'
import trimArray from 'scoreboard/components/trim-array'
import InlineTagInput from './inline-tag-input'
import InlineTextInput from './inline-text-input'
import DatePickerTooltip from './date-picker-tooltip'
import isGeographicOrRollup from 'scoreboard/datasets/is-geographic-or-rollup'
import beginsEndsWithOperators from 'scoreboard/datasets/filters/begins-ends-with-operators'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO, DATE, TEXT, CLUSTER } = DataType
import isComplete from 'scoreboard/datasets/filters/is-complete'
import { clearFilterState } from 'scoreboard/dashboards/display/dataset-filters-layout'

const DatasetFilterWidgetView = WidgetView.extend({
	className: 'widget dataset-filter',
	resizable: { width: true, height: false },
	lockedAR: false,
	configClass: DatasetFilterWidgetConfig,

	nonFetchProperties: WidgetView.prototype.nonFetchProperties
		// don't need to do dashboard data fetch for these properties because they will actually trigger a fetch
		// directly to the dataset API endpoints
		.concat(DATASET_FETCH_PROPERTIES),

	events: _.extend({
		'click .filter-value': '_onValueClick',
		'click .backward, .forward': '_onPeriodButtonClick',
		'change [name=operator]': '_onOperatorChange',
		'mouseenter .filter-value, .field-label': 'addLabelTooltip',
		'mouseleave .filter-value,  .field-label': 'removeLabelTooltip'
	}, WidgetView.prototype.events),

	initialize: function (opt) {
		WidgetView.prototype.initialize.apply(this, arguments)

		if (this.model.initialState) {
			this.currentFilter = this.model.initialState.currentFilter
		}

		this.inlineEditing = false

		this.listenTo(this.model.properties, 'change:filter', () => this.onChangeFilter())
	},

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		if (!this.dataset()) {
			// #26786 if the dashboard data doesn't have the dataset yet (like when
			// undoing a deletion, before the dashboard /data fetch is done),
			// wait until the fetch is complete
			this.listenToOnce(this.model.data, 'change', () => {
				this.render()
				this.model._maestro.query(this.datasetId())
			})

			return this
		}

		let context = this.context()

		if (this.$('.content').length === 0) {
			this.$el.append(template(context))
		} else {
			this.$('.label-operator-wrapper .field-label').text(context.label)
		}

		this.$('[name=operator], .operator').toggleClass('is-not-displayed', !this.model.properties.get('showFilterType'))

		this._renderOperatorSelect()
		this._renderFilterValue()

		this.readyForDisplayAndExport()

		// If user doesn't have permission to view the dataset, show the lock.
		// No need to continue with any of the extra calculations since we don't show those elements.
		if (!context.view) {
			this.noPermission()
			return this
		} else {
			this.showFilter(true)
		}

		// select width only changes by config, so calculate it separately from
		// the method being called on resize
		this.updateSelectWidth()
		this.listenTo(this.model.properties, 'change:showFilterType',
			() => this.updateSelectWidth())

		this.fieldLabel = this.$('.field-label')
		this.filterValueIsVisible = !this.$('.filter-value').hasClass('is-not-displayed')
		this.filterValueNotEmpty = !this.$('.filter-value').hasClass('choose')
		this.labelOperatorWrapper = this.$('.label-operator-wrapper')
		this.setLabelWidth()
		this.container.on('resized', () =>  this.setLabelWidth())

		return this
	},

	updateSelectWidth: function () {
		this.selectWidth = this.model.properties.get('showFilterType')
			? this.$('.select').width() : 0
	},

	noPermission() {
		this.showFilter(false)
		this.widgetEmptyState = new WidgetEmptyState({
			message: i18n.get('common.security.missing.datasets.view'),
			container: this.$el.closest('.wob'),
			widgetType: 'filter',
			icon: Dataset.widgetErrorIcon('common.security.missing.datasets.view')
		})
		this.$('.empty-state-container').append(this.widgetEmptyState.el)
		this.widgetEmptyState.$el.removeClass('has-drilldown')
		this.widgetEmptyState.render()
		this.readyForDisplayAndExport()
	},

	showFilter(show) {
		this.$('.main-wrapper, .period-buttons').toggleClass('is-not-displayed', !show)
		this.$('.empty-state-container').toggleClass('is-not-displayed', show)
	},

	context () {
		let dataset = this.model.data.datasetModel(this.datasetId())

		let field = dataset.combinedFieldsById[this.fieldId()]
		const vlfId = this.model.filter().visibleLinkedFieldId
		const vlf = dataset.visibleLinkedFieldsById[vlfId]
		const fieldLabel = (vlf || field).label

		return {
			label: this.model.properties.get('label') || fieldLabel,
			interactive: !this.disabled(),
			view: dataset.get('canView')
		}
	},

	// Truncate the label if the value's width is 65px or less
	setLabelWidth () {
		this.canvas.onPaint(() => {
			// #23725 need to measure actual DOM node, which won't be updated until
			// canvas has finished painting the DOM
			// Safari doesn't handle `calc(100% - 0px)` as '100%' for some reason, so
			// if there is no selectWidth, just set the max-width as 100%. Issue #29978
			let fieldLabelMaxWidth = this.selectWidth === 0 ?
				'100%' : `calc(100% - ${this.selectWidth}px)`
			this.fieldLabel.css('max-width', fieldLabelMaxWidth)
			let maxWidth = (this.filterValueIsVisible || this.filterValueNotEmpty) ?
				`calc(100% - ${VALUE_MIN_WIDTH + 10}px)` : '100%'
			this.labelOperatorWrapper.css('max-width', maxWidth)
			this.$el.toggleClass('is-hiding-content', this.$el.width() <= 50)
		})
	},

	// Add a tooltip showing the full text if the text is truncated
	addLabelTooltip(e) {
		var target = $(e.currentTarget)
		if (target[0].scrollWidth > target[0].clientWidth) {
			this.labelTooltip = new Tooltip({
				attachTo: target,
				content:  _.escape(target.text()),
				placement: 'above',
				arrow: 'center',
				closeOnAttachedToClick: false
			}).render()
		}
	},

	removeLabelTooltip() {
		_.invoke(this.labelTooltip, 'remove')
	},

	_renderOperatorSelect () {
		let field = this.field()

		let operators = operatorOptions(field, { parentDomainType: 'dashboard' })
		dropdown.object(this.$('[name=operator]').empty(), operators, this.filter().operator)
	},

	_renderFilterValue () {
		let op = this.operator()

		let field = this.field()
		let filter = this.filter()
		let dataset = this.model.data.datasetModel(this.datasetId())
		let filterHtml = filterText.noOperator(dataset, filter, field,
			this.model.data.datasetTreeItemsById(),
			{
				resolvePeriodDeltas: true,
				hiddenFilterType: !this.model.properties.get('showFilterType')
			})

		let showFilterValue
		if (this.inlineEditing) {
			// If user is in the middle of inline editing, hide the value
			showFilterValue = false
		} else {
			if (isSimpleOperator(field, op)) {
				if (this.model.properties.get('showFilterType')) {
					// If the operator is being displayed, showing 'is blank'
					// or 'is not in any range' would be redundant
					showFilterValue = false
				} else {
					// If the operator isn't being displayed, we want to show
					// the value (like 'is blank') so the user knows what's
					// been selected
					showFilterValue = true
				}
			} else {
				// For any operators that include a value, always show the value
				showFilterValue = true
			}
		}

		this.$('.filter-value')
			.toggleClass('is-not-displayed', !showFilterValue)
			.toggleClass('choose', !filterHtml)
			.html(filterHtml || i18n.get('common.choose'))

		let showPeriodButtons = false
		if (op === 'in-period') {
			showPeriodButtons = filter.calendarId != ALL_TIME

			if (showPeriodButtons) {
				let selectedPeriod
				if (!_.isNil(filter.periodDelta1)) {
					let currentPeriodId = this.model.options.getPeriodId()
					let currentPeriodIdInWidgetCalendar
					if (_.isNil(filter.calendarId)) {
						currentPeriodIdInWidgetCalendar = currentPeriodId
					} else {
						currentPeriodIdInWidgetCalendar = calendars.correspondingPeriod(
							filter.calendarId, currentPeriodId).id
					}

					selectedPeriod = calendars.safeRelativePeriod(
						currentPeriodIdInWidgetCalendar, filter.periodDelta1)
				} else {
					selectedPeriod = calendars.periodsById[filter.periodId1]
				}

				// #26927 disable backward/forward button if the filter widget is already
				// set to the first/last period
				let cal = selectedPeriod.calendar
				this.$('.period-buttons .backward')
					.toggleClass('is-disabled', cal.periods[0].id === selectedPeriod.id)
				this.$('.period-buttons .forward')
					.toggleClass('is-disabled', _.last(cal.periods).id === selectedPeriod.id)
			}
		}

		this.$el.toggleClass('has-period-buttons', showPeriodButtons)

		this.$el
			.attr('data-data-type', field.dataType)
			.attr('data-operator', filter.operator)
	},

	_onOperatorChange () {
		let operator = this.operator()
		let filter = _.cloneDeep(this.filter())
		filter.operator = operator

		let field = this.field()

		if (isGeographicOrRollup(field.dataType) && operator === 'is') {
			let keys = _.keys(filter.rollupIsAnyFilters)
			if (keys.length > 0) {
				// 'is' operator should be single tree item with descendants.
				// If there were any previous tree items, just use the first
				// one (and make certain it is set to 'true', which
				// includes descendants)
				filter.rollupIsAnyFilters = {}
				filter.rollupIsAnyFilters[keys[0]] = 'item-rollups-and-descendants'
			}
		} else if (field.dataType === DATE && operator === 'in-period') {
			// #26836 'in-period' only allows periods, not explicity dates,
			// so make sure we default to the current period if no period
			// was selected before
			if (_.isNil(filter.periodDelta1) && _.isNil(filter.periodId1)) {
				filter.periodDelta1 = 0
			}

			// 'in-period' needs to have the same value for start/end periods
			filter.periodDelta2 = filter.periodDelta1
			filter.periodId2 = filter.periodId1
		}

		this.model._maestro.changeFilter(this, filter)
	},

	_onPeriodButtonClick (e) {
		if (this.disabled()) {
			return
		}

		let forward = $(e.target).hasClass('forward')
		let delta = forward ? 1 : -1

		let filter = this.filter()
		if (!_.isNil(filter.periodDelta1)) {
			filter.periodDelta1 += delta
			filter.periodDelta2 += delta
		} else if (!_.isNil(filter.periodId1)) {
			filter.periodId1 = _.result(calendars.safeRelativePeriod(filter.periodId1, delta), 'id')
			filter.periodId2 = _.result(calendars.safeRelativePeriod(filter.periodId2, delta), 'id')
		}

		this.model._maestro.changeFilter(this, filter)
	},

	_onValueClick () {
		if (this.disabled()) {
			return
		}

		let filter = this.filter()
		let field = this.field()

		let openDialog = () => {
			this.openFilterDialog(filter, field)
		}

		if (isSimpleOperator(field, filter.operator)) {
			// If it's a simple operator with nothing else to select (like is-blank)
			// the only thing useful to do is open up the filter dialog
			openDialog()
		} else if (isGeographicOrRollup(field.dataType) && filter.operator === 'is') {
			this.openTreeItemTooltip(filter, field)
		} else if (field.dataType === YES_NO) {
			if (filter.operator === 'is-any' || filter.operator === 'is-not-any') {
				this.showInlineTagInput(filter, field)
			} else {
				openDialog()
			}
		} else if (_.includes([ TEXT, CLUSTER ], field.dataType)) {
			if (_.includes(INLINE_TEXT_OPERATORS, filter.operator)) {
				if (filter.updateType === 'calculated' || filter.updateType1 === 'calculated') {
					// #24991 if there's an equation, they need to use the dialog
					openDialog()
				} else {
					this.showInlineTextInput(filter)
				}
			} else if (_.includes(INLINE_TAG_OPERATORS, filter.operator)) {
				if (_.isEmpty(filter.equations)) {
					this.showInlineTagInput(filter, field)
				} else {
					// #26665 if there's an equation, they need to use the dialog
					openDialog()
				}
			} else {
				openDialog()
			}
		} else if (field.dataType === DATE && _.includes(DATE_PICKER_TOOLTIP_OPERATORS, filter.operator)) {
			this.openDatePickerTooltip(filter, field)
		} else {
			openDialog()
		}
	},

	onChangeFilter: function () {
		this.currentFilter = this.model.filter()
	},

	openFilterDialog: function (filter, field) {
		let startOn = twoSteps(field.dataType, filter.operator) ? 2 : 1

		let wizard = new FilterWizard({
			model: this.model.data.datasetModel(this.datasetId()),
			lockField: true,
			filter: filter,
			title: i18n.get('dashboards.datasets.editFilter'),
			step: startOn,
			allowIncomplete: true,
			allowAllTime: true,
			allowAppCalendar: true,
			parentDomainType: 'dashboard'
		}).start()

		wizard.on('done', this.onFilterUpdate.bind(this))
	},

	openTreeItemTooltip: function (filter, field) {
		let selectedTreeId = _.keys(filter.rollupIsAnyFilters)[0]
		let selector = new DatasetTreeItemSelectorTooltip({
			datasetTreeId: field.treeId,
			initialSelection: _.isNil(selectedTreeId) ? null : parseInt(selectedTreeId)
		})

		this.rollupTreeTooltip = new Tooltip({
			attachTo: this.$('.filter-value'),
			content:  selector,
			placement: 'below',
			arrow: 'center',
			extraClass: 'dataset-tree-item-selector-tooltip'
		}).render()

		this.listenTo(selector, 'select clear', selected => {
			let revisedFilter = _.cloneDeep(filter)

			// Set to the selected tree item with descendants
			revisedFilter.rollupIsAnyFilters = {}

			if (selected) {
				revisedFilter.rollupIsAnyFilters[selected.id] = 'item-rollups-and-descendants'
			}

			this.onFilterUpdate(revisedFilter, selected ? [ selected ] : [])

			this.removeRollupTreeTooltip()
		})
	},

	openDatePickerTooltip: function (filter, field) {
		let picker = new DatePickerTooltip({
			model: this.dataset(),
			filter: filter
		})

		this.datePickerTooltip = new Tooltip({
			attachTo: this.$('.filter-value'),
			content:  picker,
			placement: 'below',
			arrow: 'center',
			extraClass: 'dataset-date-filter-picker-tooltip dataset-filter',
			// The picker opens a dialog when editing the equation, so make sure
			// that doesn't close the tooltip
			closeOnDialogOpen: false
		}).render()

		this.listenTo(picker, 'change', () => {
			this.onFilterUpdate(picker.val())
		})

		// If the equation dialog is opened, make sure clicking in the dialog
		// doesn't close this tooltip
		this.listenTo(picker, 'equationDialog:open', () => {
			this.datePickerTooltip.closeOnChangedFocus = false
		})

		// Once the equation dialog is closed, go back to the normal "clicking
		// outside the tooltip closes it" behavior
		this.listenTo(picker, 'equationDialog:close', () => {
			this.datePickerTooltip.closeOnChangedFocus = true
		})

		this.listenTo(picker, 'remove', () => this.removeDatePickerTooltip())
	},

	showInlineTextInput: function (filter) {
		let input = this.inlineTextInput = new InlineTextInput({ filter })

		this.focusWob(true)

		function applyFilterChange () {
			let revisedFilter = _.cloneDeep(filter)
			revisedFilter.values = [ input.val() ]

			return revisedFilter
		}

		this.showInlineInput(filter, input, applyFilterChange,
			this.removeInlineTextInput.bind(this))
	},

	showInlineTagInput: function (filter, field) {
		// #58466
		// Allowing a blank filter for "Record is Editable" or "Record Edited"
		// fields causes unpredictable behavior, so we want to disable it for
		// that field type
		const includeBlank = !isEditField(field?.id)
		let input = this.inlineTagInput = new InlineTagInput({
			model: this.dataset(),
			filter,
			field,
			suggestions: this.model.data.datasetFieldSuggestions(filter.fieldId),
			includeBlank
		})
		this.focusWob(true)

		function applyFilterChange () {
			let revisedFilter = _.cloneDeep(filter)

			if (revisedFilter.operator === 'in-the-range') {
				revisedFilter.rangeIds = input.val()
			} else {
				revisedFilter.values = input.val()
			}

			return revisedFilter
		}

		this.showInlineInput(filter, input, applyFilterChange,
			this.removeInlineTagInput.bind(this))
	},

	showInlineInput: function (filter, inputView, applyFilterChange, onDone) {
		this.toggleInlineEditing(true)
		this.toggleFilterValue(false)

		this.$('.main-wrapper').append(inputView.el)
		inputView.render()

		this.listenTo(inputView, 'change', () => {
			this.onFilterUpdate(applyFilterChange())
		})

		this.listenTo(inputView, 'done', () => {
			this.toggleInlineEditing(false)
			this.toggleFilterValue(true)
			onDone()
		})
	},

	focusWob: function(focus) {
		this.$el.closest('.wob').toggleClass('is-focused', focus)
	},

	toggleFilterValue: function (show) {
		this.$('.filter-value').toggleClass('is-not-displayed', !show)
	},

	/**
	 * @param {Dataset} [newDataset] if the filter might be changing to a
	 * different dataset, this will be used instead of the currently assigned
	 * dataset
	 *
	 * @param {Integer} [previousDatasetId] the ID of the dataset that the
	 * filter was previously associated with. If it was not possible for the
	 * dataset to change, this can be omitted
	 */
	onFilterUpdate: function (revisedFilter, treeItems, newDataset, previousDatasetId) {
		let dataset = newDataset ?? this.dataset()

		// Add any treeItems used in the updated filter to the dashboard data,
		// since they may not have been previously loaded
		this.model.data.addDatasetTreeItems(treeItems)
		this.model.maestro().data.addDatasetTreeItems(treeItems)
		// same thing for the dataset
		this.model.data.datasetModel(dataset.id, dataset)
		this.model.maestro().data.datasetModel(dataset.id, dataset)

		// Sometimes when toggling between operator types, we end up with an
		// array with an empty string in it. This is bad; trim it out
		revisedFilter.values = trimArray(revisedFilter.values)

		dataset = this.dataset()
		let field = dataset.getUnderlyingField(revisedFilter.fieldId)
		if (isComplete(revisedFilter, field)) {
			// Now send the updated filter to maestro, which will also re-render
			// the text of the filter widget
			this.model._maestro.changeFilter(this, revisedFilter, previousDatasetId)
		} else {
			// #56442 if the filter is incomplete, have maestro treat it as a
			// deleted filter (similar to deleting a filter widget filter from
			// the drawer)
			clearFilterState(revisedFilter, dataset)
			this.model._maestro.deleteFilter(this.datasetId(), revisedFilter)
		}
	},

	toggleInlineEditing: function (editing) {
		this.inlineEditing = editing

		if (!editing) {
			this.removeEditors()
		}
	},

	datasetId () {
		return this.model.properties.get('datasetId')
	},

	dataset () {
		return this.model.data.datasetModel(this.datasetId())
	},

	fieldId () {
		return this.model.filter().fieldId
	},

	field () {
		let d = this.dataset()
		return d ? d.getUnderlyingField(this.fieldId()) : null
	},

	drilldownFieldAndId () {
		if (!isGeographicOrRollup(this.field()?.dataType)) {
			return null
		}

		let drilldownIds = _(this.filter().rollupIsAnyFilters).keys()
		if (drilldownIds.length != 1) {
			// If there are no rollup tree IDs, there's obviously no drilldown.
			// If there's more than one, we can't really use this for drilldown
			// purposes, since maps/tables drilldown to a single tree item
			return null
		}

		return {
			drilldownId: drilldownIds[0],
			fieldId: this.fieldId()
		}
	},

	operator () {
		return this.$('[name=operator]').val()
	},

	filter (newFilter) {
		if (arguments.length === 0) {
			return _.cloneDeep(_.extend(
				{},
				this.currentFilter || this.model.filter(),
				{
					// Safe to use the model's cid for the filter's cid, because
					// a filter widget only has one filter
					cid: this.model.cid,
					// Used to filter out dataset filters that come from a filter widget
					// in datasets-results.js (because user can't go "back" on a filter
					// widget) and dataset-filters-layout.js (to differentiate them from
					// filters added through the drawer UI)
					filterWidget: true
				}))
		}

		this.currentFilter = newFilter

		if (this.editing()) {
			// If we're in edit mode, update the widget model so that any changes
			// will be saved
			this.model.filter(newFilter)
		}

		this.render()
	},

	editing () {
		return Backbone.history.fragment.endsWith('/edit')
	},

	/**
	 * @override
	 */
	disabled: function () {
		if (WidgetView.prototype.disabled.apply(this, arguments)) {
			return true
		}

		if (this.editing()) {
			return true
		}

		if (layoutManager.sharedResource) {
			return true
		}

		return false
	},

	/**
	 * @override
	 */
	getState: function () {
		return {
			currentFilter: this.currentFilter
		}
	},

	removeEditors: function () {
		this.removeRollupTreeTooltip()
		this.removeDatePickerTooltip()
	},

	removeRollupTreeTooltip: function () {
		this.rollupTreeTooltip && this.rollupTreeTooltip.remove()
		delete this.rollupTreeTooltip
	},

	removeDatePickerTooltip: function () {
		this.datePickerTooltip && this.datePickerTooltip.remove()
		delete this.datePickerTooltip
	},

	removeInlineTextInput: function () {
		this.inlineTextInput && this.inlineTextInput.remove()
		delete this.inlineTextInput
		this.focusWob(false)
	},

	removeInlineTagInput: function () {
		this.inlineTagInput && this.inlineTagInput.remove()
		delete this.inlineTagInput
		this.focusWob(false)
	},

	isDrilldownExcluded: function(evtEl) {
		return this.elIsOrIsDescendantOfSelector(evtEl, '.filter-value')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelTooltip, this.widgetEmptyState], 'remove')
		this.removeEditors()
	}
})

const DATE_PICKER_TOOLTIP_OPERATORS = [ 'before', 'after', 'between-date-time', 'in-period' ]

const INLINE_TEXT_OPERATORS = beginsEndsWithOperators

const INLINE_TAG_OPERATORS = [ 'is-any', 'is-not-any', 'contains-any', 'contains-all',
	'does-not-contain-any', 'does-not-contain-all', 'in-the-range', 'not-in-any-range' ]

export default DatasetFilterWidgetView

DatasetFilterWidgetView.__filename__ = 'dashboards/widgets/dataset-filter/dataset-filter-widget-view.js'
